/**
 * Class representing the HousingAffordability Filter .
 */
export default class HousingAffordabilityFilter {
    DataPageInstance;

    filter;

    /**
     * Create a HousingAffordabilityFilter instance.
     * @param {Object} DataPageInstance - The instance of the Data Page.
     */
    constructor(DataPageInstance) {
        this.DataPageInstance = DataPageInstance;

        //
        this.initializeFilter();
    }

    /**
     * Initialize period filter inputs and add event listeners.
     */
    initializeFilter() {
        this.filter = new Choices('.js-filter-input', {
            position: 'bottom',
            itemSelectText: '',
            allowHTML: true,
            shouldSort: false,
            classNames: {
                containerOuter: 'choices data-pages__chart-select',
            },
        });

        this.filter.passedElement.element.addEventListener(
            'change',
            this.eventFilterChange.bind(this),
        );
    }

    getFilter() {
        return this.filter.getValue(true);
    }

    toggleFilterAvailability() {
        const geoParams = this.DataPageInstance.getGeoRequestParams();
        const stateId = geoParams['geoId'] ?? '';
        if (!stateId) {
            this.filter.setChoiceByValue('');
            this.disableFilter();
            return;
        }
        this.enableFilter();
        if (!this.getFilter()) {
            this.filter.setChoiceByValue('4-1');
        }
    }

    /**
     * Disable filter inputs.
     */
    disableFilter() {
        this.filter.disable();
    }

    /**
     * Enable filter inputs.
     */
    enableFilter() {
        this.filter.enable();
    }

    /**
     * Trigger the 'filterInput.Change' event.
     */
    eventFilterChange() {
        const event = new CustomEvent('filterInput.Change');

        document.dispatchEvent(event);
    }
}
